// La pantalla de la pared (el primer widget de la oficina): las ventas netas del día, su comparación con ayer y una barra
// por hora UTC (las horas cerradas de hoy en gris claro y la última en blanco; detrás, la de ayer). Pulsarla abre la Sala
// de Control. Sin oro (04-11, visual.md #1: el oro es solo para lo que pide actuar).
import { CuerpoWidget, WIDGET } from '../ui';
import { t } from '../../../i18n';
import { cn } from '../../../lib/utils';
import { delta, horaUtc, numero, SIN_VALOR } from './formato';
import type { PulsoSala } from './tipos';

export function PantallaPared({ pulso, alAbrir }: { pulso: PulsoSala | null; alAbrir: () => void }) {
  const v = pulso?.ventas;
  const d = v ? delta(v.hoy, v.ayer, false) : null;
  const aviso = pulso?.estado === 'retraso' || (pulso?.avisos.length ?? 0) > 0;
  return (
    <button type="button" onClick={alAbrir} aria-label={t('salaControl.abrir')} className={WIDGET}>
      <CuerpoWidget
        punto={!pulso ? 'sinDatos' : aviso ? 'aviso' : 'bien'}
        titulo={t('salaControl.pantalla.ventas', { hora: pulso?.hora_utc != null ? horaUtc(pulso.hora_utc, pulso.generado_at ? new Date(pulso.generado_at) : new Date()) : SIN_VALOR })}
        linea={
          d && d.direccion !== 'igual' ? (
            <span className={d.tono === 'bueno' ? 'text-oficina-trabajando' : 'text-oficina-error'}>
              {t('salaControl.pantalla.vsAyer', { delta: `${d.direccion === 'sube' ? '↑' : '↓'} ${d.texto}` })}
            </span>
          ) : null
        }
        cifra={v ? numero(v.hoy / 1000, 1) : SIN_VALOR}
        unidad={v ? 'k$' : null}
        grafico={<BarrasHora hoy={pulso?.porHora?.ventas?.hoy ?? null} ayer={pulso?.porHora?.ventas?.ayer ?? null} />}
      />
    </button>
  );
}

/** Una barra por hora UTC: las horas cerradas de hoy en gris claro y la última cerrada en blanco; detrás, apagada, la de
 *  ayer a esa hora. Decorativa: las cifras exactas están en la Sala (el widget se nombra entero con su aria-label). */
function BarrasHora({ hoy, ayer }: { hoy: Array<number | null> | null; ayer: Array<number | null> | null }) {
  if (!hoy?.length) return null;
  const max = Math.max(1, ...hoy.map((v) => v ?? 0), ...(ayer ?? []).map((v) => v ?? 0));
  const ultima = hoy.reduce<number>((u, v, i) => (v != null ? i : u), -1);
  return (
    <span className="flex h-full w-full items-end gap-0.5" data-testid="barras-hora">
      {hoy.map((v, i) => (
        <span key={i} className="relative flex h-full flex-1 items-end">
          {ayer?.[i] != null ? <span className="absolute inset-x-0 bottom-0 rounded-t-sm bg-oficina-control" style={{ height: `${(ayer[i]! / max) * 100}%` }} /> : null}
          {v != null ? (
            <span className={cn('relative w-full rounded-t-sm', i === ultima ? 'bg-oficina-texto' : 'bg-oficina-texto2')} style={{ height: `${Math.max(4, (v / max) * 100)}%` }} />
          ) : null}
        </span>
      ))}
    </span>
  );
}
